import {
  BarsLineIcon,
  CalendarLineIcon,
  ChatLineIcon,
  CheckLineIcon,
  CheckSquareLineIcon,
  CodeLineIcon,
  GlobeLineIcon,
  LaptopLineIcon,
  TrendLineIcon,
  UserCheckLineIcon,
} from '@/shared/ui/icons';

export const RESOURCE_FORMAT_ACTIONS = {
  REGISTER: 'register',
  CONTACTS: 'contacts',
};

export const RESOURCE_FORMAT_CARDS = [
  {
    group: 'format-crm',
    icon: LaptopLineIcon,
    pointIcons: [BarsLineIcon, CalendarLineIcon, TrendLineIcon],
    accent: true,
    action: RESOURCE_FORMAT_ACTIONS.REGISTER,
  },
  {
    group: 'format-site',
    icon: GlobeLineIcon,
    pointIcons: [CheckLineIcon, UserCheckLineIcon],
    action: RESOURCE_FORMAT_ACTIONS.REGISTER,
  },
  {
    group: 'format-api',
    icon: CodeLineIcon,
    pointIcons: [BarsLineIcon, CheckSquareLineIcon, ChatLineIcon],
    highlighted: true,
    action: RESOURCE_FORMAT_ACTIONS.CONTACTS,
  },
];
